// extracted by mini-css-extract-plugin
module.exports = {"MapContainer":"Map_MapContainer__32P3Q","Link":"Map_Link__2N1-m"};